<template>
  <div>
    <myHeader />

    <div class="studio_banner">
      <div class="studio_banner_content">
        <h1 class="fami">hecoos Studio</h1>
        <p style="font-size: 12px">
          让每一个设计细节都精准呈现，最大限度管控从展演的灵感到最终落地呈现的各个环节
        </p>
        <div class="callMe" @click="jumpTo('/CaseDemonstration#CallMe')">
          联系我们
        </div>
      </div>
      <div class="gradient-bg">
        <svg class="svgBlur">
          <defs>
            <filter id="goo">
              <feGaussianBlur
                in="SourceGraphic"
                stdDeviation="10"
                result="blur"
              ></feGaussianBlur>
              <feColorMatrix
                in="blur"
                mode="matrix"
                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8"
                result="goo"
              ></feColorMatrix>
              <feBlend in="SourceGraphic" in2="goo"></feBlend>
            </filter>
          </defs>
        </svg>
        <div class="gradients-container">
          <div class="g1"></div>
          <div class="g2"></div>
          <div class="g3"></div>
          <div class="g4"></div>
          <div class="g5"></div>
          <div class="interactive"></div>
        </div>
      </div>
    </div>

    <div class="bg1">
      <div class="foundation_video">
        <div class="video_start">
          <h1 style="color: white; font-size: 26px">全域制作流程</h1>
          <button class="watch-movie-button" @click="showVideo">
            <img
              src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png"
              alt=""
            />
          </button>
        </div>
        <!-- <video
          autoplay
          loop
          muted
          src="https://download.hecoos.com/enlightv/2025-17/3e04d9ef0313721c372a09dc4de0cfae.mp4"
        ></video> -->
        <img
          src="https://download.hecoos.com/enlightv/2025-20/74f6eb95683bca36efb3951249c6fdcf.png"
          alt=""
        />
      </div>
    </div>
    <div class="bann3">
      <h1 style="font-size: 26px; padding-top: 10px">核心功能点</h1>

      <mobileStudio :applicationInfo="applicationInfo" />
    </div>
    <div class="bg3">
      <div class="bgbanner">
        <h1 style="font-size: 26px">会员注册</h1>
      </div>
      <div class="sc">
        <div class="register_content">
          <div class="input-group">
            <input type="text" placeholder="真实姓名" v-model="form.rname" />
            <input type="email" placeholder="邮箱" v-model="form.email" />
          </div>

          <div class="phone-verify-group">
            <div class="phone-verify-container">
              <input
                type="text"
                placeholder="手机号"
                v-model="form.phone"
                class="phone-input"
              />
              <button
                :disabled="!isPhoneValid || isCountingDown"
                @click="obtainCode"
                class="verify-code-button"
              >
                {{ isCountingDown ? `${countdown}s后重试` : "获取验证码" }}
              </button>
            </div>
            <input
              type="text"
              placeholder="验证码"
              v-model="form.verifyCode"
              class="verify-input"
            />
          </div>

          <div class="input-group">
            <input
              type="password"
              placeholder="设置密码"
              v-model="form.password"
            />
            <input
              type="password"
              placeholder="确认密码"
              v-model="form.confirmPassword"
            />
          </div>

          <div class="input-group">
            <input
              type="text"
              placeholder="所在公司名称"
              v-model="form.company"
            />
            <input type="text" placeholder="所在城市" v-model="form.city" />
          </div>

          <div class="input-group">
            <input type="text" placeholder="职位" v-model="form.position" />
<!--            <input-->
<!--              type="text"-->
<!--              placeholder="从业时间"-->
<!--              v-model="form.workDuration"-->
<!--            />-->
            <select  placeholder="从业时间" :class="{'none_select' : !form.workDuration}" v-model="form.workDuration">
              <option value="" disabled selected>从业时间</option>
              <option v-for="item in workDurationList" :value="item.name">{{item.name}}</option>
            </select>
          </div>
          <p class="tip" style="text-align: left">
            为保证您能快速通过审核，请填写真实有效的信息
          </p>
          <button
            class="next-button"
            :disabled="!isButtonEnabled"
            @click="goRegister"
          >
            下一步
          </button>
        </div>
      </div>
    </div>
    <div class="bg4">
      <div>
        <h2 class="title" style="font-size: 26px">软件订阅</h2>
      </div>
      <div class="subscription-container">
        <div
          v-for="(item, index) in subscriptionOptions"
          :key="index"
          class="subscription-item"
        >
          <h3 class="item-title">{{ item.title }}</h3>
          <div v-if="item.price" class="price">
            {{ item.price }}<span class="z">/周</span>
          </div>
          <p v-else class="description">{{ item.description }}</p>
          <button class="btn" @click="goToPage(item.path)">进一步了解</button>
        </div>
      </div>
    </div>

    <!-- 下载部分和学习方案 -->
    <div class="bg5">
      <div id="app">
        <!-- 下载部分 -->
        <div class="download-section">
          <div class="left-content">
            <img
              src="../../../asset/mobile/mobile_studio/download.png"
              alt="下载图标"
            />
          </div>
          <div class="right-content">
            <h2 style="font-size: 26px">下载</h2>
            <p>立即下载，熟悉软件，开始创建新现实！</p>
            <div class="le">
              <button class="download-btn" @click="getdown">软件下载</button>
              <a href="https://download.hecoos.com/hecoos/hecoosGuide.pdf"
                ><button class="guide-btn">下载指南</button></a
              >
            </div>
          </div>
        </div>
        <!-- 学习方案部分 -->
        <div class="learning-plan-section">
          <div class="right-content">
            <img
              src="../../../asset/mobile/mobile_studio/study.png"
              alt="学习场景"
            />
          </div>
          <div class="left-content">
            <h2 style="font-size: 26px">学习方案</h2>
            <p>适合您需求和节奏的学习体验。</p>
            <div class="le">
              <router-link
                :to="{ name: 'chMobileVideoTutorial' }"
                class="setting_a2"
              >
                <button class="more-btn">了解更多</button>
              </router-link>
              <router-link
                :to="{
                  name: 'chMobile_CaseDemonstration',
                  hash: '#CallMe',
                }"
                class="setting_a2"
              >
                <button class="customize-btn">定制您的学习方案</button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <myListen /> -->
    <myInquire />
    <myFooter />
    <videoPlayback
      v-if="showVideoPlayer"
      @close="handleCloseVideo"
      :videoUrl="videoUrl"
    />
  </div>
</template>


<script>
import { getOSSData } from "@/utils/uploadOss.js";
import myHeader from "@/components/mobile/myHeader.vue";
import myFooter from "@/components/mobile/myFooter.vue";
import mobileStudio from "@/components/mobile/mobileStudio.vue";
// import myListen from "@/components/mobile/myListen.vue";
import myInquire from "@/components/mobile/myInquire.vue";
import videoPlayback from "@/components/mobile/videoPlayback.vue";
import axios from "axios";
import { getCaptcha, adminRegister } from "@/api/api";
import { Message } from "element-ui";
export default {
  components: {
    // myListen,
    myInquire,
    myHeader,
    myFooter,
    mobileStudio,
    videoPlayback,
  },

  data() {
    return {
      showVideoPlayer: false,
      videoUrl:
        "https://download.hecoos.com/enlightv/2025-17/a7b39397e5b52ac2f16d0e201a71d1f3.mp4",
      bannertext:
        "hecoos以三维可视化界面预演完整的活动过程，精准模拟视频、灯光、机械、交互、导播等舞台元素，艺术家与工程师通过预演协作探讨并清晰确立演出方案的每一处细节，是提升现场执行效率与准确率的坚实保障",
      applicationInfo: [
        {
          imgUrl: "https://download.hecoos.com/enlightv/2025-37/b9a8561ed2d3a3bc239784458f646dd9.gif",
          video_src:'https://download.hecoos.com/enlightv/2025-37/6e569024f657be36a636d806995b2c05.mp4',
          title: " 三维场景预演 ",
          msg: "hecoos以三维可视化界面预演完整的活动过程，精准模拟视频、灯光、机械、交互、导播等舞台元素，艺术家与工程师通过预演协作探讨并清晰确立演出方案的每一处细节，是提升现场执行效率与准确率的坚实保障。",
        },
        {
          imgUrl:"https://download.hecoos.com/enlightv/2025-37/e2a6710b551d4589205a1859ac1839de.gif",
          video_src:'https://download.hecoos.com/enlightv/2025-37/c2425b299fdea228a893c92c0941fec7.mp4',
          title: " 投影光路设计 ",
          msg: " 模拟真实投影机的光路和画面畸变，精准测量投影机在实际环境中的照度和遮挡区域，通过内置多个品牌多种参数的投影机，轻松完成各种复杂模型的光路设计。 ",
        },
        {
          imgUrl:"https://download.hecoos.com/enlightv/2025-37/5ea6dc35423ef1a273401a7736ca289b.gif",
          video_src:'https://download.hecoos.com/enlightv/2025-37/94bc0146f0b0954d3e1e0ac10295cbb6.mp4',
          title: " 灯光预演与预编程 ",
          msg: " 灯光效果对于舞台气氛的烘托极为重要，hecoos内置主流品牌灯具，基于Art-Net协议配接，实现灯光的预编程、现场真实灯具控制，模拟三维场景中真实光影效果，再现舞台现场灯光的绚丽多彩。 ",
        },
        {
          imgUrl:"https://download.hecoos.com/enlightv/2025-37/c799c3f249148bdac945f5455bf566f4.gif",
          video_src:'https://download.hecoos.com/enlightv/2025-37/8d690d28c5a754ae6e38d5dc3dc97ca9.mp4',
          title: " 导播系统 ",
          msg: " 内置多种类型摄像机(摇臂、轨道等)，提前预演摄像机拍摄画面，基于时间轴的控制方式，实现精准的导播切换。同时可基于CUE点管理生成电子台本，将导播设计和现场执行无缝对接，通过云端来实现协同工作，可完成无人值守的导播切换任务 ",
        },
        {
          imgUrl: "https://download.hecoos.com/enlightv/2025-37/3d9fa2275c28f924075e25b0f9b914a2.gif",
          video_src:'https://download.hecoos.com/enlightv/2025-37/ceace489abff2bfd1c57917adeea3a48.mp4',
          title: " 现场控制 ",
          msg: " Studio将预演工程与现场执行环节轻松串联，作为项目调试阶段多媒体设备的核心控制枢纽，Studio 凭借其精准的通讯与控制能力，确保各设备之间稳定、协调地运行。多人协同调试使团队协作更加流畅高效。 ",
        },
      ],
      formRows: [
        [
          {
            label: "真实姓名",
            type: "input",
            inputType: "text",
            name: "realName",
            placeholder: "真实姓名", // 添加占位符文本
          },
          {
            label: "邮箱",
            type: "input",
            inputType: "email",
            name: "email",
            placeholder: "邮箱", // 添加占位符文本
          },
        ],
        [
          {
            label: "手机号",
            type: "input-with-button",
            inputType: "text",
            name: "phone",
            clickHandler: function () {
              this.sendVerificationCode();
            },
            text: "获取验证码",
            placeholder: "手机号", // 添加占位符文本
          },
          {
            label: "验证码",
            type: "input",
            inputType: "text",
            name: "verificationCode",
            placeholder: "验证码", // 添加占位符文本
          },
        ],
        [
          {
            label: "设置密码",
            type: "input",
            inputType: "password",
            name: "password",
            placeholder: "设置密码", // 添加占位符文本
          },
          {
            label: "确认密码",
            type: "input",
            inputType: "password",
            name: "confirmPassword",
            placeholder: "确认密码", // 添加占位符文本
          },
        ],
        [
          {
            label: "所在公司名称",
            type: "input",
            inputType: "text",
            name: "companyName",
            placeholder: "所在公司名称", // 添加占位符文本
          },
          {
            label: "所在城市",
            type: "input",
            inputType: "text",
            name: "city",
            placeholder: "所在城市", // 添加占位符文本
          },
        ],
        [
          {
            label: "职位",
            type: "input",
            inputType: "text",
            name: "position",
            placeholder: "职位", // 添加占位符文本
          },
          {
            label: "从业时间",
            type: "input",
            inputType: "text",
            name: "workExperience",
            placeholder: "从业时间", // 添加占位符文本
          },
        ],
      ],
      formData: {},
      form: {
        rname: "",
        phone: "",
        verifyCode: "",
        password: "",
        confirmPassword: "",
        email: "",
        company: "",
        city: "",
        position: "",
        workDuration: "",
      },
      isCountingDown: false,
      countdown: 60,
     errorMessages: [], // 新增：收集所有错误信息
      isSending: false,
      countdown: 60,
      timer: null,

      subscriptionOptions: [
        {
          title: "订阅版",
          price: "¥98",
          path: "/SoftwareSubscriptions",
        },
        {
          title: "离线版",
          description: "独立加密锁，离线亦可工作",
          path: "/offlineversion",
        },
      ],

      hue1: 0,
      hue2: 0,
      workDurationList:[
        {name:'1年'},
        {name:'2年'},
        {name:'3年'},
        {name:'4年'},
        {name:'5年'},
        {name:'6年'},
        {name:'7年'},
        {name:'8年'},
        {name:'9年'},
        {name:'10年以上'}
      ]
    };
  },
  computed: {
    isButtonEnabled() {
      return (
        // 所有必填字段都填写且密码一致
        this.form.rname &&
        this.form.email &&
        this.form.phone &&
        this.form.verifyCode &&
        this.form.password &&
        this.form.confirmPassword &&
        this.form.company &&
        this.form.city &&
        this.form.position &&
        this.form.workDuration &&
        this.form.password === this.form.confirmPassword
      );
    },
    isPhoneValid() {
      const phoneRegex = /^1[3-9]\d{9}$/;
      return phoneRegex.test(this.form.phone);
    },
  },
  mounted () {

  },
  methods: {
    handleMouseMove(event) {
      const x = event.clientX / window.innerWidth;
      const y = event.clientY / window.innerHeight;

      this.hue1 = Math.floor(x * 360);
      this.hue2 = Math.floor(y * 360);
    },
    goToPage(path) {
      this.$router.push(path);
    },
    //下载软件接口
    getdown() {
      const config = {
        method: "post", // 请求方法
        url: "https://www.hecoos.com/api/index/hecoosPath", // 请求 URL
        timeout: 5000, // 请求超时时间（毫秒）
      };
      axios(config)
        .then((res) => {
          if (res) {
            const { version, packageUrl } = res.data;
            let file_name = `hecoos Studio v${version}.exe`;
            getOSSData(packageUrl, file_name);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    showVideo() {
      this.showVideoPlayer = true;
      document.body.style.overflow = "hidden"; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = "auto"; // 恢复页面滚动
    },
    jumpTo(url) {
      this.$router.push(url);
    },
  // 中文姓名校验
    checkRname(str) {
      let reg = /^[\u4e00-\u9fa5]{2,}$/;
      return reg.test(str);
    },

    // 邮箱校验
    isEmailValid(str) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(str);
    },

    // 验证码校验（6位数字）
    checkVerifyCode(str) {
      let reg = /^\d{6}$/;
      return reg.test(str);
    },

    // 密码校验
    checkPassword(str) {
      return str.length >= 6;
    },

    // 公司名称校验（至少2个汉字）
    checkCompany(str) {
      let reg = /^[\u4e00-\u9fa5]{2,}$/;
      return reg.test(str);
    },

    // 城市校验（中文）
    checkCity(str) {
      let reg = /^[\u4e00-\u9fa5]+$/;
      return reg.test(str);
    },

    // 职位校验（至少2个字符）
    checkPosition(str) {
      let reg = /^.{2,}$/;
      return reg.test(str);
    },

    // 工作年限校验（数字或数字+年）
    checkWorkDuration(str) {
      let reg = /^\d+(\s*年)?$/;
      return reg.test(str);
    },

   obtainCode() {
      // 先校验手机号格式
      if (!this.isPhoneValid) {
        Message.error("请输入正确的手机号格式");
        return;
      }

      let postData = {
        phone: this.form.phone,
      };
      getCaptcha(postData).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.startCountdown();
        } else {
          Message.error(res.message);
        }
      });
    },

   //注册
    goRegister() {
      // 执行完整表单校验
      if (!this.validateForm()) {
        return;
      }

      adminRegister(this.form).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.$router.push("/login");
        } else {
          Message.error(res.message || "注册失败，请重试");
        }
      });
    },

    validateForm() {
      const errors = [];

      // 收集所有错误
      if (!this.checkRname(this.form.rname))
        errors.push("请输入中文姓名（至少2个字符）");
      if (!this.isPhoneValid) errors.push("手机号格式不正确，请重新输入");
      if (!this.isEmailValid(this.form.email))
        errors.push("邮箱格式不正确，请重新输入");
      if (this.form.verifyCode && !this.checkVerifyCode(this.form.verifyCode))
        errors.push("请输入6位数字的验证码");
      if (this.form.password && !this.checkPassword(this.form.password))
        errors.push("密码长度至少为6位");
      if (this.form.password !== this.form.confirmPassword)
        errors.push("两次输入的密码不一致");
      if (!this.checkCompany(this.form.company))
        errors.push("请输入正确的公司名称（至少2个汉字）");
      if (!this.checkCity(this.form.city)) errors.push("请输入中文城市名称");
      if (!this.checkPosition(this.form.position))
        errors.push("请输入职位（至少2个字符）");
      if (!this.checkWorkDuration(this.form.workDuration))
        errors.push("请输入正确的从业时间（如：1年、3）");

      // 延迟显示错误
      if (errors.length > 0) {
        errors.forEach((msg, index) => {
          setTimeout(() => {
            Message.error(msg);
          }, 500 * index);
        });
        return false;
      }

      return true;
    },

    startCountdown() {
      this.isCountingDown = true;
      let timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(timer);
          this.isCountingDown = false;
          this.countdown = 60;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/en_mobile/studio_banner.scss";
.callMe {
  width: 80px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  background-color: #2a82e4;
  margin: 0 auto;
  margin-top: 20px;
  text-align: center;
  font-size: 12px;
  transition: 0.3s ease;
  cursor: pointer;
  color: white;
  position: relative;
  z-index: 50;
}

.callMe:hover {
  transform: scale(1.05);
  background-color: #fff;
  color: #2a82e4;
}
@media screen and (min-width: 768px) {
      .callMe {
      width: 180px;
      height: 50px;
      line-height: 50px;
      border-radius: 30px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 18px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    }
</style>
<style scoped lang="scss">
@media screen and (min-width: 768px) {
  container {
    position: relative;
    overflow: hidden;
  }
  .fami {
    font-size: 50px !important;
  }
  .studio_banner_content p {
    padding-top: 20px;
    font-size: 20px !important;
  }
  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 20px;
    border-radius: 10px;
  }

  .bg {
    background-image: url("../../../asset/mobile/mobile_studio/cover.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: 0px 43px;
    height: 36vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .verify-code-button {
  width: 150px !important;
  padding: 20px !important;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  height: auto;
  position: absolute;
  right: 0;
  font-size: 18px !important;
}

.input-group input,
.phone-verify-group input {
  width: 48%;
  padding: 20px !important;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  font-size: 18px !important;
  transition: border-color 0.3s;
}

  .bg1 {
    background: black;
  }

  .bann3 {
    width: 100%;
    background-color: #000;
    padding: 30px;
    color: #fff;
    text-align: center;
    h1 {
      font-size: 45px !important;
    }
  }

  .bann3 img {
    width: 100%;
  }

  .bann3 h1 {
    font-size: 28px;
    font-weight: 700;
    color: rgba(255, 255, 255, 1);
    vertical-align: top;
    text-align: center;
    color: white;
    padding: 0px 0px 30px 0;
  }

  .bann3cent {
    text-align: center;
  }

  .bann3cent img {
    width: 100%;
  }

  .bann3cent p {
    font-size: 14px;
    text-align: center;
    color: white;
    font-family: YourFontName2;
  }

  .contain {
    text-align: center;
  }

  .contain p {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    vertical-align: top;
    padding-top: 10px;
  }

  .banncenter {
    text-align: center;
    padding: 10px 0px;
  }

  .banncenter video {
    width: 100%;
  }

  .headbanner h1 {
    font-size: 28px;
    font-weight: 400;
    line-height: 30px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    vertical-align: top;
  }

  .headbanner p {
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 30px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    vertical-align: top;
  }

  .bg3 {
    background-image: url("../../../asset/mobile/mobile_studio/register.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    padding: 0px 43px;
  }

  .form-container {
    margin: 0 auto;
  }

  .form-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .form-item {
    width: 47%;
    background-color: #24272a;
    border-radius: 10px;
    padding: 10px;
    position: relative;
  }

  .form-item label {
    display: block;
    margin-bottom: 5px;
    color: #ccc;
  }

  .form-item input {
    width: 100%;
    border: none;
    border-radius: 5px;
    background-color: #24272a;
    color: #fff;
    font-size: 18px !important;
  }

  .form-item input::placeholder {
    font-size: 18px !important;
  }

  .input-with-button {
    display: flex;
    align-items: center;
  }

  .input-with-button input {
    flex: 1;
    margin-right: 10px;
  }

  .test {
    color: white;
    background-color: transparent;
    border: none;
    cursor: pointer;
    position: absolute;
    left: 70% !important;

    bottom: 10px;
    font-family: YourFontName2;
    font-size: 18px !important;
  }

  .tip {
    color: white;
    margin-bottom: 15px;
    font-size: 18px !important;
    font-family: YourFontName2;
    padding: 10px 0px;
  }

  .next-button {
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 20px;
    background-color: #147cf5;
    color: #fff;
    font-size: 18px !important;
    cursor: pointer;
    transition: all 0.5s ease;
  }

  .next-button:hover {
    background-color: white;
    color: #147cf5;
    transform: scale(1.05);
  }

  .bgbanner h1 {
    font-size: 45px !important;
    text-align: center;
    color: white;
    padding: 35px 0px;
  }

  .bg4 {
    background: black;
    padding: 15px 43px 0;
  }

  .title {
    font-size: 45px !important;
    text-align: center;
    color: white;
    padding: 35px 0px;
  }

  .subscription-container {
    background-color: #000;
    color: #fff;
    padding: 0 0 15px 0;
  }

  .subscription-item {
    background-color: #232428;
    border-radius: 15px;
    text-align: center;
    padding: 40px;
    transition: all 0.3s ease;
    margin: 50px 0 0 0;
  }

  .subscription-item:nth-child(1) {
    margin-top: 0;
  }

  .subscription-item:hover {
    box-shadow: 5px 5px 20px #147cf5;
  }

  .item-title {
    font-size: 40px !important;
    text-align: center;
    background: linear-gradient(
      to right,
      rgba(234, 212, 254, 1),
      rgba(40, 189, 181, 1)
    );
    /* 定义渐变方向和颜色 */
    -webkit-background-clip: text;
    /* 裁剪背景以适应文字形状，Webkit内核 */
    background-clip: text;
    /* 裁剪背景以适应文字形状，标准语法 */
    color: transparent;
    padding: 20px 0 5px 0;
  }

  .price {
    font-size: 35px !important;
    padding: 15px 0;
  }

  .z {
    font-size: 20px !important;
  }

  .description {
    padding: 15px 0;
    font-size: 30px !important;
  }

  .btn {
    background-color: #147cf5;
    color: white;
    padding: 5px 40px;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    transition: background 0.3s ease;
    margin: 20px 0;
    width: 185px;
    height: 50px;
    font-size: 18px;
  }

  .btn:hover {
    background: linear-gradient(to right, #e0004a, #e22d8e);
  }

  .bg5 {
    background: black;
  }

  #app {
    color: white;
    background-color: #000;
    padding: 40px 43px;
  }
  .bg5 #app {
    padding-top: 0;
  }
  .left-content img {
    width: 100%;
    padding: 40px 0;
  }

  .left-content h2,
  .right-content h2 {
    margin-bottom: 20px;
    font-size: 45px !important;
    vertical-align: top;
    text-align: left;
  }

  .left-content p,
  .right-content p {
    margin-bottom: 30px;
    vertical-align: top;
    text-align: left;
    font-size: 20px !important;
  }

  .right-content img {
    width: 100%;
    padding: 40px 0;
  }

  .download-btn,
  .guide-btn,
  .more-btn,
  .customize-btn {
    padding: 10px 20px;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    vertical-align: bottom;
    margin-right: 15px;
    width: 185px !important;
    height: 50px !important;
    font-size: 18px;
  }

  .le {
    text-align: left;
    vertical-align: bottom;
  }

  .download-btn,
  .more-btn {
    background-color: #147cf5;
    color: white;
    border-radius: 30px;
    transition: all 0.5s ease;
  }

  .download-btn:hover,
  .more-btn:hover {
    background-color: white;
    color: #147cf5;
    transform: scale(1.05);
  }

  .guide-btn,
  .customize-btn {
    background-color: #000000;
    color: white;
    border: 1px solid white;
    border-radius: 30px;
    transition: all 0.5s ease;
  }

  .guide-btn:hover,
  .customize-btn:hover {
    transform: scale(1.05);
    background-color: white;
    color: #000;
  }

  .foundation_video {
    width: 100%;
    position: sticky;
    top: 0;
    justify-content: center;
    align-items: center;

    object-fit: cover;

    img {
      width: 100%;
      object-fit: cover;
    }
  }

  .watch-movie-button {
    width: 50px !important;
    height: 50px !important;
    border-radius: 36.65px;
    border: 2px solid white;
    background-color: rgba(0, 0, 0, 0.1);
  }

  .video_start {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 999;
    h1 {
      font-size: 45px !important;
    }
  }

  .video_start img {
    width: 100%;
  }

  .foundation_video video {
    width: 100%;
    object-fit: cover;
  }
}
.container {
  position: relative;
  overflow: hidden;
}

.content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 20px;
  border-radius: 10px;
}

.bg {
  background-image: url("../../../asset/mobile/mobile_studio/cover.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 0px 43px;
  height: 36vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bg1 {
  background: black;
}

.bann3 {
  width: 100%;
  background-color: #000;
  padding: 0 43px;
  color: #fff;
  text-align: center;
}

.bann3 img {
  width: 100%;
}

.bann3 h1 {
  font-size: 28px;
  font-weight: 700;
  color: rgba(255, 255, 255, 1);
  vertical-align: top;
  text-align: center;
  color: white;
  padding: 0px 0px 30px 0;
}

.bann3cent {
  text-align: center;
}

.bann3cent img {
  width: 100%;
}

.bann3cent p {
  font-size: 14px;
  text-align: center;
  color: white;
  font-family: YourFontName2;
}

.contain {
  text-align: center;
}

.contain p {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  padding-top: 10px;
}

.banncenter {
  text-align: center;
  padding: 10px 0px;
}

.banncenter video {
  width: 100%;
}

.headbanner h1 {
  font-size: 28px;
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
}

.headbanner p {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 30px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
}

.bg3 {
  background-image: url("../../../asset/mobile/mobile_studio/register.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 0px 43px;
}

.form-container {
  margin: 0 auto;
}

.form-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.form-item {
  width: 47%;
  background-color: #24272a;
  border-radius: 10px;
  padding: 10px;
  position: relative;
}

.form-item label {
  display: block;
  margin-bottom: 5px;
  color: #ccc;
}

.form-item input {
  width: 100%;
  border: none;
  border-radius: 5px;
  background-color: #24272a;
  color: #fff;
  font-size: 10px;
}

.form-item input::placeholder {
  font-size: 10px;
}

.input-with-button {
  display: flex;
  align-items: center;
}

.input-with-button input {
  flex: 1;
  margin-right: 10px;
}

.test {
  color: white;
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  left: 55%;
  bottom: 10px;
  font-family: YourFontName2;
  font-size: 11px;
}

.tip {
  color: white;
  margin-bottom: 8px;
  font-size: 13px;
  font-family: YourFontName2;
  padding: 10px 0px;
}

.next-button {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 20px;
  background-color: #147cf5;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.5s ease;
}

.next-button:hover {
  background-color: white;
  color: #147cf5;
  transform: scale(1.05);
}

.bgbanner h1 {
  font-size: 28px;
  text-align: center;
  color: white;
  padding: 35px 0px;
}

.bg4 {
  background: black;
  padding: 15px 43px 0;
}

.title {
  font-size: 28px;
  text-align: center;
  color: white;
  padding: 35px 0px;
}

.subscription-container {
  background-color: #000;
  color: #fff;
  padding: 0 0 15px 0;
}

.subscription-item {
  background-color: #232428;
  border-radius: 15px;
  text-align: center;

  transition: all 0.3s ease;
  margin: 50px 0 0 0;
}

.subscription-item:nth-child(1) {
  margin-top: 0;
}

.subscription-item:hover {
  box-shadow: 5px 5px 20px #147cf5;
}

.item-title {
  font-size: 20px;
  text-align: center;
  background: linear-gradient(
    to right,
    rgba(234, 212, 254, 1),
    rgba(40, 189, 181, 1)
  );
  /* 定义渐变方向和颜色 */
  -webkit-background-clip: text;
  /* 裁剪背景以适应文字形状，Webkit内核 */
  background-clip: text;
  /* 裁剪背景以适应文字形状，标准语法 */
  color: transparent;
  padding: 20px 0 5px 0;
}

.price {
  font-size: 20px;
  padding: 15px 0;
}

.z {
  font-size: 12px;
}

.description {
  padding: 15px 0;
  font-size: 12px;
}

.btn {
  background-color: #147cf5;
  color: white;
  padding: 5px 40px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: background 0.3s ease;
  margin: 20px 0;
}

.btn:hover {
  background: linear-gradient(to right, #e0004a, #e22d8e);
}

.bg5 {
  background: black;
}

#app {
  color: white;
  background-color: #000;
  padding: 40px 43px;
}
.bg5 #app {
  padding-top: 0;
}
.left-content img {
  width: 100%;
  padding: 40px 0;
}

.left-content h2,
.right-content h2 {
  margin-bottom: 20px;
  font-size: 28px;
  vertical-align: top;
  text-align: left;
}

.left-content p,
.right-content p {
  margin-bottom: 30px;
  vertical-align: top;
  text-align: left;
  font-size: 14px;
}

.right-content img {
  width: 100%;
  padding: 40px 0;
}

.download-btn,
.guide-btn,
.more-btn,
.customize-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  vertical-align: bottom;
  margin-right: 15px;
}

.le {
  text-align: left;
  vertical-align: bottom;
}

.download-btn,
.more-btn {
  background-color: #147cf5;
  color: white;
  border-radius: 30px;
  transition: all 0.5s ease;
}

.download-btn:hover,
.more-btn:hover {
  background-color: white;
  color: #147cf5;
  transform: scale(1.05);
}

.guide-btn,
.customize-btn {
  background-color: #000000;
  color: white;
  border: 1px solid white;
  border-radius: 30px;
  transition: all 0.5s ease;
}

.guide-btn:hover,
.customize-btn:hover {
  transform: scale(1.05);
  background-color: white;
  color: #000;
}

.foundation_video {
  width: 100%;
  position: sticky;
  top: 0;
  justify-content: center;
  align-items: center;

  object-fit: cover;

  img {
    width: 100%;
    object-fit: cover;
  }
}

.watch-movie-button {
  width: 32px;
  height: 32px;
  border-radius: 36.65px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, 0.1);
}

.video_start {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 999;
}

.video_start img {
  width: 100%;
}

.foundation_video video {
  width: 100%;
  object-fit: cover;
}
.bgc {
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("https://download.hecoos.com/enlightv/2025-17/88bbd52c2dca3a58360b8aa5ad07d60d.png");
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
  position: relative;
}

.register_content {
  width: 100%;

  border-radius: 15px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  color: #fff;
  position: relative;
  z-index: 1;
}

.register_content h2 {
  margin-bottom: 20px;
  font-size: 32px;
}

.register_content p {
  margin-bottom: 10px;
  font-size: 12px;
}

.input-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.input-group input,
.input-group select,
.phone-verify-group input {
  width: 48%;
  padding: 10px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  font-size: 10px;
  transition: border-color 0.3s;
}
.input-group select.none_select {
  color: #757575;
}
.input-group select:focus-visible{
  border: none;
  outline: none;
}

.phone-verify-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.phone-verify-container {
  display: flex;
  width: 48%;
  position: relative;
}

.phone-input {
  flex: 1;
  font-size: 18px;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #333;
  color: #fff;
  width: 100%;
  height: auto;
}

.verify-code-button {
  width: 80px;
  padding: 10px;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  height: auto;
  position: absolute;
  right: 0;
  font-size: 10px;
}

.verify-input {
  width: 48%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  height: auto;
  font-size: 10px;
}

.next-button {
  width: 100%;
  padding: 10px 0;
  border: none;
  border-radius: 8px;
  background-color: #fff;
  color: #222;
  cursor: pointer;
  margin-bottom: 10px;
  font-size: 10px;
  transition: all 0.3s;
}

.next-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.link-container {
  font-size: 10px;
  color: #fff;
  cursor: pointer;
}
</style>
